module.exports = __webpack_public_path__ + "resources/img/zoom_logo_dark.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_logo_dark.png
// module id = 1099
// module chunks = 0